// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-169df442]{color:var(--main-theme-color);letter-spacing:normal}.image[data-v-169df442]{width:100%;height:100%}.form[data-v-169df442]{margin:0 auto;width:500px}.submit-button[data-v-169df442]{background-color:var(--main-theme-color);font-weight:700;color:#fff}.company-info-box[data-v-169df442]{width:500px;margin:60px auto 80px}.company-info-box span[data-v-169df442]{display:block;font-size:18px;font-weight:700}", ""]);
// Exports
module.exports = exports;
